<template>
  <OverviewActions type="tickets" :item-id="ticket.id" info />
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

import OverviewActions from '@/components/UI/OverviewActions'

export default defineComponent({
  name: 'TicketRowActions',
  components: {
    OverviewActions,
  },
  props: {
    ticket: {
      type: Object,
      required: true,
    },
    pendingTickets: {
      type: Array,
      default: _ => [],
    },
  },
  setup(props, { emit }) {
    const isTicketPending = computed(_ => props.pendingTickets.indexOf(props.ticket.id) !== -1)

    return {
      isTicketPending,
    }
  },
})
</script>
